// Zona horaria oficial de Betel Natural: California, con PST/PDT automático.
export const BUSINESS_TIME_ZONE = 'America/Los_Angeles';

export const businessToday = () => new Intl.DateTimeFormat('en-CA', {
  timeZone: BUSINESS_TIME_ZONE,
  year: 'numeric', month: '2-digit', day: '2-digit'
}).format(new Date());

export const businessDateTime = (value, locale = 'en-US', options = {}) =>
  new Intl.DateTimeFormat(locale, { ...options, timeZone: BUSINESS_TIME_ZONE }).format(new Date(value));

// Las fechas calendario (YYYY-MM-DD) no son instantes UTC y no deben cambiar de día.
export const businessCalendarDate = (value, locale = 'en-US', options = {}) => {
  if (!value) return '';
  const datePart = String(value).slice(0, 10);
  const date = new Date(datePart + 'T12:00:00Z');
  return new Intl.DateTimeFormat(locale, { ...options, timeZone: 'UTC' }).format(date);
};
